export const REQUIRED = 'This field is required';